import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { deviceRows } from '../../data/mockBackedAdapters'
import { MOCK_BACKED_AREAS, buildMockGap } from '../../data/reportModel'
import Chip from '../../components/Chip/Chip'
import MockedPanel from '../../components/MockedPanel/MockedPanel'
import ReportTable from '../../components/ReportTable/ReportTable'
import SubBlock from '../../components/SubBlock/SubBlock'

export default function Device({ dataAvailability }) {
  const stats = [
    {
      key: 'total',
      value: '-',
      label: <FormattedMessage id="AI_RISK_REPORT.IDENTITY.DEVICE.STAT_TOTAL" />,
    },
    {
      key: 'noncompliant',
      value: '-',
      label: <FormattedMessage id="AI_RISK_REPORT.IDENTITY.DEVICE.STAT_NONCOMPLIANT" />,
    },
    {
      key: 'personal',
      value: '-',
      label: <FormattedMessage id="AI_RISK_REPORT.IDENTITY.DEVICE.STAT_PERSONAL" />,
    },
  ]
  const columns = [
    {
      key: 'device',
      header: <FormattedMessage id="AI_RISK_REPORT.COL.DEVICE" />,
      render: (row) => <span className="text-body fw-bold">{row.device}</span>,
      sortable: true,
      sortValue: (row) => row.device,
    },
    {
      key: 'user',
      header: <FormattedMessage id="AI_RISK_REPORT.COL.USER" />,
      render: (row) => row.user,
      sortable: true,
      sortValue: (row) => row.user,
    },
    {
      key: 'os',
      header: <FormattedMessage id="AI_RISK_REPORT.COL.OS" />,
      render: (row) => row.os,
      sortable: true,
      sortValue: (row) => row.os,
    },
    {
      key: 'issue',
      header: <FormattedMessage id="AI_RISK_REPORT.COL_ISSUE" />,
      render: (row) => <Chip tone={row.tone}>{row.issue}</Chip>,
      sortable: true,
      sortValue: (row) => row.issue,
    },
  ]

  return (
    <SubBlock
      titleId="AI_RISK_REPORT.IDENTITY.DEVICE.TITLE"
      subtitleId="AI_RISK_REPORT.IDENTITY.DEVICE.SUBTITLE"
      mocked
      hideFromExport
      stats={stats}
    >
      <MockedPanel gap={buildMockGap(dataAvailability, MOCK_BACKED_AREAS.DEVICES)}>
        <ReportTable columns={columns} rows={deviceRows} />
      </MockedPanel>
    </SubBlock>
  )
}

Device.propTypes = { dataAvailability: PropTypes.arrayOf(PropTypes.shape({})).isRequired }
